/** First letters of the first and last words of the name, upper-cased; falls back to the email. */
export function initialsOf(name: string, email: string): string {
  const words = name.trim().split(/\s+/).filter((w) => w.length > 0);
  const first = words[0];
  const last = words.length > 1 ? words[words.length - 1] : undefined;
  if (first) {
    return `${first.charAt(0)}${last ? last.charAt(0) : ''}`.toUpperCase();
  }
  return (email.trim().charAt(0) || '?').toUpperCase();
}
